import { Component, Injector } from '@angular/core';


import { MatDialog } from '@angular/material/dialog';
import { GaeUser, MyService } from 'src/app/services/my.service';
import { ViewComponent } from '../../abstract/view.component';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/app/environments/environment';

@Component({
  selector: 'privacy',
  styleUrls: ['./privacy.component.scss'],
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent extends ViewComponent {

  version = 'latest';
  markdownPath = `assets/${environment.privacyPolicyPath}/latest.md`;

  constructor(
    protected override injector: Injector,
    private route: ActivatedRoute,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const version = this.route.snapshot.paramMap.get('version');
    if (version) {
      console.log(version)
      this.markdownPath = `assets/${environment.privacyPolicyPath}/${version}.md`;
    }

  }
}
